import React from "react";
import { useTranslation } from "react-i18next";
import {
  BoomTestimonial,
  BoomTestimonial1Name,
  BoomTestimonial1Review,
  BoomTestimonial2Name,
  BoomTestimonial2Review,
  BoomTestimonial3Name,
  BoomTestimonial3Review,
  BoomTestimonial4Name,
  BoomTestimonial4Review,
  BoomTestimonial5Name,
  BoomTestimonial5Review,
} from "../../../Constants";
import Preview1 from "../../../assets/1-preview.webp";
import Preview3 from "../../../assets/3-preview.webp";

const BoomTestimonials = () => {
  const { t } = useTranslation();

  const DATA = [
    {
      name: t(BoomTestimonial3Name),
      review: t(BoomTestimonial3Review),
      type: "video",
      file: "https://riise-media.s3.us-east-1.amazonaws.com/resources/videos/Testimonials+/3.mp4",
      preview: Preview3,
    },
    {
      name: t(BoomTestimonial2Name),
      review: t(BoomTestimonial2Review),
      type: "image",
      file: "https://riise-media.s3.us-east-1.amazonaws.com/resources/images/testimonials/2.webp",
    },

    {
      name: t(BoomTestimonial1Name),
      review: t(BoomTestimonial1Review),
      type: "video",
      file: "https://riise-media.s3.us-east-1.amazonaws.com/resources/videos/Testimonials+/1.mp4",
      preview: Preview1,
    },
    {
      name: t(BoomTestimonial4Name),
      review: t(BoomTestimonial4Review),
      type: "image",
      file: "https://riise-media.s3.us-east-1.amazonaws.com/resources/images/testimonials/4.webp",
    },
    {
      name: t(BoomTestimonial5Name),
      review: t(BoomTestimonial5Review),
      type: "image",
      file: "https://riise-media.s3.us-east-1.amazonaws.com/resources/images/testimonials/5.webp",
    },
  ];
  return (
    <div className="t-flex t-flex-col t-gap-4">
      <h2 className="t-text-center md:t-text-left">{t(BoomTestimonial)}</h2>
      <div
        className={`t-flex t-items-start t-gap-4 t-w-full t-overflow-scroll t-mx-auto hide-scrollbar`}
      >
        {DATA.map((item, index) => (
          <Card {...item} key={"boom-testimonial-" + index} />
        ))}
      </div>
    </div>
  );
};

const Card = ({ file, name, review, type, preview }) => {
  return (
    <div className="t-flex-none t-max-w-[250px]">
      <div className="t-relative t-group ">
        {type === "video" ? (
          <video
            controls
            className="t-relative t-flex-none t-w-full t-object-cover t-h-[400px] !t-rounded-lg"
            poster={preview}
            playsInline
          >
            <source src={file} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img
            src={file}
            alt=""
            className="t-relative t-flex-none t-w-full t-object-cover t-h-[400px] !t-rounded-lg"
          />
        )}
      </div>

      <h3 className="t-text-lg t-font-semibold t-text-center !t-m-0">{name}</h3>
      <p className="t-text-gray-600 !t-m-0 t-text-center">{review}</p>
    </div>
  );
};

export default BoomTestimonials;
